// @flow
import getLogger, { LEVELS as LOG_LEVELS } from "common/logger";

const logger = getLogger();

const C_BLUE = "color:#057aff;";
const C_GREEN = "color:#20b832;";
const C_GRAY = "color:#5b616a";

export default (store: { getState: Function }) => (next: Function) => (action: { type: string, payload: any }) => {
	let result; let
		groupStarted = false;

	if (logger.getLevel() === LOG_LEVELS.LOG) {
		try {
			const prevState = store.getState();
			result = next(action);
			const nextState = store.getState();

			logger.groupCollapsed(`Uploader Store Log For -> ${action.type}`);
			groupStarted = true;

			logger.log(`%c dispatched action TYPE - ${action.type}`, C_BLUE);

			if (action.payload) {
				logger.log("%c dispatched action PAYLOAD - ", C_GREEN, action.payload);
			}

			if (nextState !== prevState) {
				logger.log("previous state - ", prevState.uploader);
				logger.log("next state - ", nextState.uploader);
			} else {
				logger.log("%c state hasn't changed after action", C_GRAY);
				logger.log("%c state - ", C_GRAY, nextState.uploader);
			}
		} catch (err) {
			logger.warn("[Store Logger] failed to log store action details", err);
		}
	}

	if (groupStarted) {
		logger.groupEnd();
	}

	return result || next(action);
};
